export const receiptCard_37 = {
    default: {
        backgroundColor: '#F5F5F5',
        color: '#86888C',
        '& hr': {
            borderColor: '#D3D4D3 !important',
        },
        '& a.link': {
            color: '#A13EA1 !important',
        }
    },
    white : {
        color: '#86888C',
    },
    yellow: {
        backgroundColor: '#F8D2B3',
        color: '#86888C',
        '& hr': {
            borderColor: '#f5a623',
        },
        '& a.link': {
            color: '#A13EA1 !important',
        }
    },
}